import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const useUserClaims = () => {
  const { currentUser } = useAuth();
  const [claims, setClaims] = useState({
    isAdmin: false,
    isTier1User: false,
    isTier2User: false,
    isTier3User: false,
    isTier4User: false,
    isTier5User: false,
    loading: true,
    error: null
  });

  useEffect(() => {
    const checkUserClaims = async () => {
      if (currentUser) {
        try {
          setClaims(prev => ({ ...prev, loading: true, error: null }));
          
          const token = await currentUser.getIdTokenResult(true);
          
          // Extract all claims
          const newClaims = {
            isAdmin: !!token.claims.isAdmin,
            isTier1User: !!token.claims.isTier1User,
            isTier2User: !!token.claims.isTier2User,
            isTier3User: !!token.claims.isTier3User,
            isTier4User: !!token.claims.isTier4User,
            isTier5User: !!token.claims.isTier5User,
            loading: false,
            error: null
          };
          
          setClaims(newClaims);
        } catch (error) {
          console.error("Error checking user claims:", error);
          setClaims(prev => ({
            ...prev,
            loading: false,
            error: error.message
          }));
        }
      } else {
        // Reset claims when no user
        setClaims({
          isAdmin: false,
          isTier1User: false,
          isTier2User: false,
          isTier3User: false,
          isTier4User: false,
          isTier5User: false,
          loading: false,
          error: null
        });
      }
    };

    checkUserClaims();
  }, [currentUser]);

  return claims;
};